// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image-gallery-grid[data-v-11ecf3ec]{display:grid;grid-template-columns:repeat(auto-fill,minmax(15rem,1fr));gap:1rem}.image-gallery-grid .custom-image[data-v-11ecf3ec]{-moz-column-break-inside:avoid;break-inside:avoid;padding:1rem;border:1px solid var(--color-border)}.image-gallery-grid>div[data-v-11ecf3ec] .image-hover{cursor:default}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
